// removed by extract-text-webpack-plugin
module.exports = {"Loading":"Home__Loading__3rv94","ModalBtnGroup":"Home__ModalBtnGroup__3OsPD","MenuLink":"Home__MenuLink__1-plp","MenuBox":"Home__MenuBox__DBNhM","SectionTitle":"Home__SectionTitle__3tj38","Note":"Home__Note__2U-Lx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 383
// module chunks = 0